import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#004c66',
                secondary: '#E0E0E0',
                accent: '#326f84',
            },
        },
    },
})
